var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.shopDeviceTransAuditRecList, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "retailerComName", label: "机构名称", align: "left" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "auditorName",
              label: "审核人",
              width: "120",
              align: "left"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "auditTime",
              label: "审核时间",
              width: "160",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "auditState",
              label: "审核状态",
              width: "100",
              align: "center"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    rows.row.auditState === 0
                      ? _c("span", { staticClass: "font-red" }, [
                          _vm._v("未审核")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    rows.row.auditState === 1
                      ? _c("span", { staticClass: "font-green" }, [
                          _vm._v("已通过")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    rows.row.auditState === -1
                      ? _c("span", { staticClass: "font-red" }, [
                          _vm._v("未通过")
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "auditDesc",
              label: "审核描述",
              width: "160",
              align: "left"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d56d9c6a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d56d9c6a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/transVoucher/ShopDeviceTransAuditResList.vue
// module id = 2562
// module chunks = 0